import React from 'react';
import Inner from '../Inner';

/**
 * Column widths, as fractions of the block's `gridSize` (12 on both stored
 * instances). These names come from the pre-archive editor, which stored the
 * NAME rather than the number -- so the mapping has to live somewhere, and
 * this is it.
 */
const COLUMN_SPANS = {
  full: 12,
  halfWidth: 6,
  oneThird: 4,
  twoThirds: 8,
  quarter: 3,
  threeQuarters: 9,
};

/**
 * Legacy `columnsBlock`, view only.
 *
 * Two archive pages use it at the top level (`halfWidth/halfWidth` and
 * `twoThirds/oneThird`), and three more instances are nested inside the tabs
 * block on `/directives/directives_process` -- which is why this renders
 * through the same `Inner` bridge as everything else rather than special-casing
 * its children.
 *
 * The columns themselves are stored ANONYMOUSLY: each is a bare
 * `{blocks, blocks_layout}` with no `@type`, so they are not looked up in
 * `blocksConfig` and are rendered here directly.
 */
const ColumnsView = ({ data = {}, ...rest }) => {
  const holder = data.data || {};
  const columns = (holder.blocks_layout?.items || [])
    .map((uid) => [uid, holder.blocks?.[uid]])
    .filter(([, column]) => column);

  if (columns.length === 0) return null;

  const gridSize = data.gridSize || 12;
  const names = data.gridCols || [];
  // An unnamed column divides the row evenly -- the honest fallback when the
  // stored gridCols is shorter than the column list.
  const evenSpan = Math.max(1, Math.floor(gridSize / columns.length));

  return (
    <div
      className="archives-columns"
      style={{ '--archives-columns-total': gridSize }}
    >
      {columns.map(([uid, column], index) => (
        <div
          key={uid}
          className="archives-columns__column"
          style={{
            '--archives-column-span': COLUMN_SPANS[names[index]] || evenSpan,
          }}
        >
          <Inner holder={column} {...rest} />
        </div>
      ))}
    </div>
  );
};

export { COLUMN_SPANS };
export default ColumnsView;
